export function getCurrentAppVersion(): string | undefined {
  const injected = import.meta.env.VITE_APP_VERSION as string | undefined;

  if (injected) {
    return injected;
  }

  if (typeof document === 'undefined') {
    return undefined;
  }

  return (
    document.querySelector('meta[name="portal-version"]')?.getAttribute('content') ?? undefined
  );
}
